export const DAMM_RED = '#EB0505'
